import { useCallback, useEffect, useState } from 'react';
import { axiosInstance } from '../../../Helper/Api/axios.instance';
import { AppConfig } from '../../../Config/app-config';
import { useUserContext } from '../../../context/user.context';

type WithdrawType = {
  id: number;
  eventId: number;
  timestamp: string;
  claimableAt: string;
  transactionHash: string;
  blockNumber: number;
  shares: number;
  amountReceived: number;
  token: string;
  processed: boolean;
};

export const useWithdraw = () => {
  const { isLoggedIn } = useUserContext();
  const [withdrawList, setWithdrawList] = useState<WithdrawType[]>([]);

  const fetchWithdrawList = useCallback(async () => {
    try {
      const { data } = await axiosInstance.get<{
        items: WithdrawType[];
        total: number;
      }>(AppConfig.apiRoutes.listWithdraw());

      setWithdrawList(data?.items);
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      void fetchWithdrawList();
    } else {
      setWithdrawList([]);
    }
  }, [isLoggedIn]);

  return {
    withdrawList,
    fetchWithdrawList,
  };
};
